export default __webpack_public_path__ + "static/news2-6ca4868fd8114e2588be6b4cc88147d5.png";